import React, { useState } from 'react';
import layoutBlank from '../../assets/Layouts/blank.png';
import layoutTitleBody from '../../assets/Layouts/layout01.png';
import layoutTitleTwoColumns from '../../assets/Layouts/layout02.png';
import layoutSectionHeader from '../../assets/Layouts/layout03.png';
import layoutTitleOneColumn from '../../assets/Layouts/layout04.png';
import layoutTitleOnly from '../../assets/Layouts/layout05.png';
import LayoutEnum from '../../utils/layoutEnum';
import { modifyMasterSlideData, removeDuplicates } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import layoutsArray from '../../utils/layoutStructure';
import { slideAction } from '../../store/slideSlice';
import { v4 } from "uuid";
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { slideAPI } from '../../store/api';

const MasterSlideSideBar = ({ selectedSlideLayout, setSelectedSlideLayout }) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const existingSlides = useSelector((state) => state.slide.slides);

    const handleSlideClick = (e,slideId) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedSlideLayout(slideId);
        let existingLayoutId;
        if (slideId === 'master') {
            existingLayoutId = Object.keys(existingSlides).find(key => {
                // Check if the key contains "master" but not any layout enum value
                const containsMaster = key.toLowerCase().includes('master');
                const containsEnumLayout = Object.values(LayoutEnum).some(layout => key.toLowerCase().includes(layout.toLowerCase()));
                return containsMaster && !containsEnumLayout;
            });
        }
        else {
            existingLayoutId = Object.keys(existingSlides).find(id => id.toLowerCase().includes(slideId.toLowerCase()));
        }
        existingLayoutId && dispatch(slideAction.setMasterSlideId(existingLayoutId));
        existingLayoutId && dispatch(slideAction.setCurrentSlide(existingLayoutId));

    };

    const renderImage = (image, id) => (
        <img
            src={image}
            width={'180px'}
            style={{
                border: `1px solid ${selectedSlideLayout === id ? '#6eb7fa' : 'silver'}`,
                borderWidth: selectedSlideLayout === id ? '2px' : '1px',
                cursor: 'pointer',
                marginBottom: '20px',
            }}
            onClick={(e) => handleSlideClick(e,id)}
            alt={`Layout ${id}`}
        />
    );

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                <span>THEME</span>
                {renderImage(layoutBlank, 'master')}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexWrap: 'wrap' }}>
                <span>LAYOUTS</span>
                {renderImage(layoutTitleBody, LayoutEnum.TITLE_BODY)}
                {renderImage(layoutTitleTwoColumns, LayoutEnum.TITLE_TWO_COLUMNS)}
                {renderImage(layoutSectionHeader, LayoutEnum.SECTION_HEADER)}
                {renderImage(layoutTitleOneColumn, LayoutEnum.TITLE_ONE_COLUMN)}
                {renderImage(layoutTitleOnly, LayoutEnum.TITLE_ONLY)}
                {renderImage(layoutBlank, LayoutEnum.BLANK)}
            </div>
        </div>
    );
};

export default MasterSlideSideBar;